import React from "react";
import Menu from "../containers/Menu/Menu";
import { LoadingScreenBlank } from "./Diversos";

export default function Func({ children, showMenu = true, loading, ...props }) {
  return (
    <>
      {/* {showMenu && <MenuLateral loading={loading} path={props.path} />} */}
      {showMenu && <Menu loading={loading} path={props.path} />}

      {loading && <LoadingScreenBlank loading={loading} />}
      <div className={props.large ? "container-padrao-large" : "container-padrao"} {...props}>
        {children}
      </div>
    </>
  );
}
